/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import {
  TRANSACTION_RENTAL,
  TRANSACTION_SALE,
  TRANSACTION_SEASONAL_RENTAL
} from '../../enums/TransactionCodes.mjs'
import Filter, { FilterableProps } from '../Filter'
import useArrayFilter from '../../../../client/js/hooks/useArrayFilter'
import { Checkbox, Radio } from '@mantine/core'

function EstateTransactionFilter (props: FilterableProps<string[]>) {
  const { onChange, value } = props
  const intl = useIntl()
  const [array, handleChange] = useArrayFilter(value, onChange)
  return (
    <Filter>
      <Radio
        checked={array.length === 0}
        id="estate_transaction_all_filter"
        label={intl.formatMessage({
          id: 'all',
          defaultMessage: 'Tout'
        })}
        name="transaction"
        onChange={(event) => {
          if (event.target.checked) {
            onChange(event.target.name, undefined)
          }
        }}
        value=""
      />
      <Checkbox
        checked={array.includes(TRANSACTION_RENTAL)}
        id="estate_transaction_rental_filter"
        label={intl.formatMessage({
          id: 'rental',
          defaultMessage: 'Location'
        })}
        name="transaction"
        onChange={handleChange}
        value={TRANSACTION_RENTAL}
      />
      <Checkbox
        checked={array.includes(TRANSACTION_SEASONAL_RENTAL)}
        id="estate_transaction_seasonal_rental_filter"
        label={intl.formatMessage({
          id: 'seasonal_rental',
          defaultMessage: 'Location saisonnière'
        })}
        name="transaction"
        onChange={handleChange}
        value={TRANSACTION_SEASONAL_RENTAL}
      />
      <Checkbox
        checked={array.includes(TRANSACTION_SALE)}
        id="estate_transaction_sale_filter"
        label={intl.formatMessage({
          id: 'sale',
          defaultMessage: 'Vente'
        })}
        name="transaction"
        onChange={handleChange}
        value={TRANSACTION_SALE}
      />
    </Filter>
  )
}

export default EstateTransactionFilter
